// import React from "react";
// import * as Tabs from "@radix-ui/react-tabs";

// import Product from "./Product";
// import Certificate from "./Certificate";
// import Client from "./Client";
// import Collaboration from "./Collaboration";
// import Research from "./Research";

// export default function ProductAndService() {
//   return (
//     <section id="products" className="py-20 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <Tabs.Root defaultValue="product">
//           <Tabs.List className="flex space-x-4 border-b border-gray-200 mb-8">
//             <Tabs.Trigger
//               className="px-6 py-3 text-gray-700 hover:text-purple-600 font-semibold radix-state-active:border-b-2 radix-state-active:border-purple-600 focus:outline-none"
//               value="product"
//             >
//               Products
//             </Tabs.Trigger>
//             <Tabs.Trigger
//               className="px-6 py-3 text-gray-700 hover:text-purple-600 font-semibold radix-state-active:border-b-2 radix-state-active:border-purple-600 focus:outline-none"
//               value="certificate"
//             >
//               Certificate
//             </Tabs.Trigger>
//             <Tabs.Trigger
//               className="px-6 py-3 text-gray-700 hover:text-purple-600 font-semibold radix-state-active:border-b-2 radix-state-active:border-purple-600 focus:outline-none"
//               value="clients"
//             >
//               Clients
//             </Tabs.Trigger>
//             <Tabs.Trigger
//               className="px-6 py-3 text-gray-700 hover:text-purple-600 font-semibold radix-state-active:border-b-2 radix-state-active:border-purple-600 focus:outline-none"
//               value="collaboration"
//             >
//               Collaboration
//             </Tabs.Trigger>
//             <Tabs.Trigger
//               className="px-6 py-3 text-gray-700 hover:text-purple-600 font-semibold radix-state-active:border-b-2 radix-state-active:border-purple-600 focus:outline-none"
//               value="research"
//             >
//               Research
//             </Tabs.Trigger>
//           </Tabs.List>

//           <Tabs.Content value="product">
//             <Product />
//           </Tabs.Content>

//           <Tabs.Content value="certificate">
//             <Certificate />
//           </Tabs.Content>

//           <Tabs.Content value="clients">
//             <Client />
//           </Tabs.Content>

//           <Tabs.Content value="collaboration">
//             <Collaboration />
//           </Tabs.Content>

//           <Tabs.Content value="research">
//             <Research />
//           </Tabs.Content>
//         </Tabs.Root>
//       </div>
//     </section>
//   );
// }

// import React from "react";
// import * as Tabs from "@radix-ui/react-tabs";

// import Product from "./Product";
// import Certificate from "./Certificate";
// import Client from "./Client";
// import Collaboration from "./Collaboration";
// import Research from "./Research";

// export default function ProductAndService() {
//   return (
//     <section id="products" className="py-20 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <Tabs.Root defaultValue="product">
//           <Tabs.List className="flex justify-center space-x-4 border-b border-gray-200 mb-8">
//             {[
//               { label: "Products", value: "product" },
//               { label: "Certificate", value: "certificate" },
//               { label: "Clients", value: "clients" },
//               { label: "Collaboration", value: "collaboration" },
//               { label: "Research", value: "research" },
//             ].map((tab) => (
//               <Tabs.Trigger
//                 key={tab.value}
//                 className="px-6 py-3 text-gray-700 hover:text-purple-600 font-semibold radix-state-active:border-b-2 radix-state-active:border-purple-600 focus:outline-none"
//                 value={tab.value}
//               >
//                 {tab.label}
//               </Tabs.Trigger>
//             ))}
//           </Tabs.List>

//           <div className="flex justify-center">
//             <div className="w-full max-w-6xl">
//               <Tabs.Content value="product">
//                 <Product />
//               </Tabs.Content>

//               <Tabs.Content value="certificate">
//                 <Certificate />
//               </Tabs.Content>

//               <Tabs.Content value="clients">
//                 <Client />
//               </Tabs.Content>

//               <Tabs.Content value="collaboration">
//                 <Collaboration />
//               </Tabs.Content>

//               <Tabs.Content value="research">
//                 <Research />
//               </Tabs.Content>
//             </div>
//           </div>
//         </Tabs.Root>
//       </div>
//     </section>
//   );
// }

// //manage selected tab and change
// import { React, useState } from "react";
// import * as Tabs from "@radix-ui/react-tabs";
// import { X } from "tabler-icons-react";

// import Product from "./Product";
// import Accessories from "./Accessories";

// import Certificate from "./Certificate";
// import Client from "./Client";
// import Collaboration from "./Collaboration";
// import Research from "./Research";
// import Software from "./Software";

// export default function ProductAndService({ selectedTab, onTabChange }) {
//   const [selectedPDF, setSelectedPDF] = useState(null);
//   return (
//     <section id="products" className="py-20 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <Tabs.Root value={selectedTab} onValueChange={onTabChange}>
//           {/* <Tabs.List className="flex justify-center space-x-4 border-b border-gray-200 mb-8">
//             {[
//               { label: "Products", value: "product" },
//               { label: "Accessories", value: "accessories" },
//               { label: "Certificate", value: "certificate" },
//               { label: "Clients", value: "clients" },
//               { label: "Collaboration", value: "collaboration" },
//               { label: "Research", value: "research" },
//             ].map((tab) => (
//               <Tabs.Trigger
//                 key={tab.value}
//                 className="px-6 py-3 text-gray-700 hover:text-purple-600 font-semibold radix-state-active:border-b-2 radix-state-active:border-purple-600 focus:outline-none"
//                 value={tab.value}
//               >
//                 {tab.label}
//               </Tabs.Trigger>
//             ))}
//           </Tabs.List> */}
//           {/* new */}
//           <Tabs.List className="flex flex-wrap md:flex-nowrap justify-start md:justify-center overflow-x-auto scrollbar-hide gap-2 border-b border-gray-200 mb-8 px-2">
//             {[
//               { label: "Products", value: "product" },
//               { label: "Software", value: "software" },
//               { label: "Accessories", value: "accessories" },
//               { label: "Certificate", value: "certificate" },
//               { label: "Clients", value: "clients" },
//               { label: "Collaboration", value: "collaboration" },
//               { label: "Research", value: "research" },
//             ].map((tab) => (
//               <Tabs.Trigger
//                 key={tab.value}
//                 className="whitespace-nowrap px-4 py-2 text-sm md:text-base text-gray-700 hover:text-purple-600 font-semibold radix-state-active:border-b-2 radix-state-active:border-purple-600 focus:outline-none"
//                 value={tab.value}
//               >
//                 {tab.label}
//               </Tabs.Trigger>
//             ))}
//           </Tabs.List>

//           <div className="flex justify-center">
//             <div className="w-full max-w-6xl">
//               <Tabs.Content value="product">
//                 <Product setSelectedPDF={setSelectedPDF} />
//               </Tabs.Content>

//               <Tabs.Content value="software">
//                 <Software />
//               </Tabs.Content>

//               <Tabs.Content value="accessories">
//                 <Accessories />
//               </Tabs.Content>

//               <Tabs.Content value="certificate">
//                 <Certificate />
//               </Tabs.Content>

//               <Tabs.Content value="clients">
//                 <Client />
//               </Tabs.Content>

//               <Tabs.Content value="collaboration">
//                 <Collaboration />
//               </Tabs.Content>

//               <Tabs.Content value="research">
//                 <Research />
//               </Tabs.Content>
//             </div>
//           </div>
//         </Tabs.Root>
//       </div>
//       {selectedPDF && (
//         <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4">
//           <div className="bg-white rounded-lg max-w-4xl w-full relative">
//             <button
//               onClick={() => setSelectedPDF(null)}
//               style={{ top: "0px", right: "-45px" }}
//               className="absolute top-0 right-0 p-5 text-red-600 bg-white rounded-full shadow-md"
//             >
//               <X className="w-6 h-6" />
//             </button>
//             <iframe
//               src={selectedPDF}
//               title="Product Brochure"
//               className="w-full h-[80vh] rounded-b-lg"
//             />
//           </div>
//         </div>
//       )}
//     </section>
//   );
// }

////new
// import { React, useState } from "react";
// import * as Tabs from "@radix-ui/react-tabs";
// import { X } from "tabler-icons-react";

// import Product from "./Product";
// import Accessories from "./Accessories";

// import Certificate from "./Certificate";
// import Client from "./Client";
// import Collaboration from "./Collaboration";
// import Research from "./Research";
// import Software from "./Software";

// export default function ProductAndService({ selectedTab, onTabChange }) {
//   const [selectedPDF, setSelectedPDF] = useState(null);
//   return (
//     <section id="products" className="py-20 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <Tabs.Root value={selectedTab} onValueChange={onTabChange}>
//           {/* <Tabs.List
//             className="
//               flex
//               flex-nowrap
//               justify-start
//               overflow-x-auto
//               scrollbar-hide
//               space-x-2
//               border-b border-gray-200 mb-8 px-2
//               sm:justify-center
//             "
//             aria-label="Product and Service Tabs"
//           >
//             {[
//               { label: "Products", value: "product" },
//               { label: "Software", value: "software" },
//               { label: "Accessories", value: "accessories" },
//               { label: "Certificate", value: "certificate" },
//               { label: "Clients", value: "clients" },
//               { label: "Collaboration", value: "collaboration" },
//               { label: "Research", value: "research" },
//             ].map((tab) => (
//               <Tabs.Trigger
//                 key={tab.value}
//                 className="
//                   whitespace-nowrap
//                   px-4 py-2
//                   text-sm md:text-base
//                   text-gray-700 hover:text-purple-600
//                   font-semibold
//                   radix-state-active:border-b-2
//                   radix-state-active:border-purple-600
//                   focus:outline-none
//                   focus-visible:ring-2
//                   focus-visible:ring-purple-600
//                   rounded
//                 "
//                 value={tab.value}
//               >
//                 {tab.label}
//               </Tabs.Trigger>
//             ))}
//           </Tabs.List> */}
//           <Tabs.List
//             className="
//     flex
//     flex-nowrap
//     justify-start
//     overflow-x-auto
//     scrollbar-hide
//     space-x-2
//     border border-gray-300 rounded-lg bg-gray-50
//     mb-8 px-2 py-1
//     sm:justify-center
//   "
//             aria-label="Product and Service Tabs"
//           >
//             {[
//               { label: "Products", value: "product" },
//               { label: "Software", value: "software" },
//               { label: "Accessories", value: "accessories" },
//               { label: "Certificate", value: "certificate" },
//               { label: "Clients", value: "clients" },
//               { label: "Collaboration", value: "collaboration" },
//               { label: "Research", value: "research" },
//             ].map((tab) => (
//               <Tabs.Trigger
//                 key={tab.value}
//                 className="
//         whitespace-nowrap
//         px-5 py-2
//         text-sm md:text-base
//         text-gray-700
//         bg-transparent
//         rounded-md
//         hover:bg-purple-100
//         focus:outline-none
//         focus-visible:ring-2
//         focus-visible:ring-purple-600
//         font-semibold
//         radix-state-active:bg-purple-600
//         radix-state-active:text-white
//         radix-state-active:shadow-md
//         transition
//         select-none
//         cursor-pointer
//       "
//                 value={tab.value}
//               >
//                 {tab.label}
//               </Tabs.Trigger>
//             ))}
//           </Tabs.List>

//           <div className="flex justify-center">
//             <div className="w-full max-w-6xl">
//               {/* Only active tab content is rendered/shown */}
//               <Tabs.Content value="product">
//                 <Product setSelectedPDF={setSelectedPDF} />
//               </Tabs.Content>

//               <Tabs.Content value="software">
//                 <Software />
//               </Tabs.Content>

//               <Tabs.Content value="accessories">
//                 <Accessories />
//               </Tabs.Content>

//               <Tabs.Content value="certificate">
//                 <Certificate />
//               </Tabs.Content>

//               <Tabs.Content value="clients">
//                 <Client />
//               </Tabs.Content>

//               <Tabs.Content value="collaboration">
//                 <Collaboration />
//               </Tabs.Content>

//               <Tabs.Content value="research">
//                 <Research />
//               </Tabs.Content>
//             </div>
//           </div>
//         </Tabs.Root>
//       </div>

//       {selectedPDF && (
//         <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4">
//           <div className="bg-white rounded-lg max-w-4xl w-full relative">
//             <button
//               onClick={() => setSelectedPDF(null)}
//               style={{ top: "0px", right: "-45px" }}
//               className="absolute top-0 right-0 p-5 text-red-600 bg-white rounded-full shadow-md"
//               aria-label="Close PDF viewer"
//             >
//               <X className="w-6 h-6" />
//             </button>
//             <iframe
//               src={selectedPDF}
//               title="Product Brochure"
//               className="w-full h-[80vh] rounded-b-lg"
//             />
//           </div>
//         </div>
//       )}
//     </section>
//   );
// }

//new
import React, { useState } from "react";
import * as Tabs from "@radix-ui/react-tabs";
import { X } from "tabler-icons-react";

import Product from "./Product";
import Accessories from "./Accessories";

import Certificate from "./Certificate";
import Client from "./Client";
import Collaboration from "./Collaboration";
import Research from "./Research";
import Software from "./Software";

export default function ProductAndService({ selectedTab, onTabChange }) {
  const [selectedPDF, setSelectedPDF] = useState(null);

  return (
    <section id="products" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Tabs.Root value={selectedTab} onValueChange={onTabChange}>
          <Tabs.List
            className="
              flex
              flex-nowrap
              justify-start
              overflow-x-auto
              scrollbar-hide
              space-x-2
              border border-gray-300
              rounded-lg bg-gray-50
              mb-8 px-2 py-1
              sm:justify-center
            "
            aria-label="Product and Service Tabs"
          >
            {[
              { label: "Products", value: "product" },
              { label: "Software", value: "software" },
              { label: "Accessories", value: "accessories" },
              { label: "Certificate", value: "certificate" },
              { label: "Clients", value: "clients" },
              { label: "Collaboration", value: "collaboration" },
              { label: "Research", value: "research" },
            ].map((tab) => (
              <Tabs.Trigger
                key={tab.value}
                value={tab.value}
                className="
                  whitespace-nowrap
                  px-5 py-2
                  text-sm md:text-base
                  text-gray-700
                  bg-transparent
                  rounded-md
                  hover:bg-purple-100
                  focus:outline-none
                  focus-visible:ring-2
                  focus-visible:ring-purple-600
                  font-semibold
                  radix-state-active:bg-purple-600
                  radix-state-active:text-white
                  radix-state-active:shadow-md
                  transition
                  select-none
                  cursor-pointer
                "
              >
                {tab.label}
              </Tabs.Trigger>
            ))}
          </Tabs.List>

          <div className="flex justify-center">
            <div className="w-full max-w-6xl">
              <Tabs.Content value="product">
                <Product setSelectedPDF={setSelectedPDF} />
              </Tabs.Content>

              <Tabs.Content value="software">
                <Software />
              </Tabs.Content>

              <Tabs.Content value="accessories">
                <Accessories />
              </Tabs.Content>

              <Tabs.Content value="certificate">
                <Certificate />
              </Tabs.Content>

              <Tabs.Content value="clients">
                <Client />
              </Tabs.Content>

              <Tabs.Content value="collaboration">
                <Collaboration />
              </Tabs.Content>

              <Tabs.Content value="research">
                <Research />
              </Tabs.Content>
            </div>
          </div>
        </Tabs.Root>
      </div>

      {selectedPDF && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-4xl w-full relative">
            <button
              onClick={() => setSelectedPDF(null)}
              style={{ top: "0px", right: "-45px" }}
              className="absolute top-0 right-0 p-5 text-red-600 bg-white rounded-full shadow-md"
              aria-label="Close PDF viewer"
            >
              <X className="w-6 h-6" />
            </button>
            <iframe
              src={selectedPDF}
              title="Product Brochure"
              className="w-full h-[80vh] rounded-b-lg"
            />
          </div>
        </div>
      )}
    </section>
  );
}
